import React from "react";
import PropTypes from "prop-types";
import { validateForm } from "utils/validation";
import { FoodTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddFoodTypeForm from "./Components/AddFoodTypeForm";
import Fields from "../json/FoodTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { Create } from 'adminApi/FoodTypeApi/FoodType';

/**
 * AddFoodType — Smart container for creating new food types.
 * Manages form state, validation, and submission.
 * 
 * @param {Object} props
 * @param {Function} props.setRefetch - Callback to trigger list refresh.
 * @param {boolean} props.refetch - Current refetch state.
 */
const AddFoodType = ({ setRefetch, refetch }) => {
    const { formdata } = Fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues } = useFormChange(
        initialValues,
        FoodTypeRules
    );

    // Form submit handler - handles API call and success callback
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Create({ data: formData });
        },
        (vals) => validateForm(vals, FoodTypeRules),
        () => {
            // Reset form on success
            setValues(initialValues);
            setRefetch(!refetch);
        },
        "Food Type created successfully."
    );

    return (
        <>
            {loadingSubmit && <Spinner isSpinner />}
            <AddFoodTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Add Food Categories"
            />
        </>
    );
};

AddFoodType.propTypes = {
    setRefetch: PropTypes.func.isRequired,
    refetch: PropTypes.bool.isRequired,
};

AddFoodType.defaultProps = {
    setRefetch: () => { },
    refetch: false,
};

export default AddFoodType;
